import { useState } from 'react';
import { InputGroup, FormControl, Button } from 'react-bootstrap';

const InputWithButton = ({ placeholder = "Enter text...", title = "Submit", onSubmit }) => {
  const [value, setValue] = useState('');

  const handleClick = () => {
    if (onSubmit) onSubmit(value);
    setValue('');
  };

  return (
    <InputGroup className="mb-3">
      <FormControl
        placeholder={placeholder}
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />
      <Button variant="primary" onClick={handleClick}>
        {title}
      </Button>
    </InputGroup>
  );
};

export default InputWithButton;
